import { render } from "./LinksComponent.vue?vue&type=template&id=0537343a&ts=true"
import script from "./LinksComponent.vue?vue&type=script&lang=ts"
export * from "./LinksComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__